/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const QuestionMark16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <g fill="currentColor" transform="translate(3.5 .5)">
      <path d="M5.465 10.5h-2.02v-1a4.11 4.11 0 0 1 2.19-3.563C6.545 5.294 6.98 4.943 6.98 4c0-1.74-1.582-2-2.525-2-1.39.14-2.162.577-3.036 1.657L0 2.25C1.236.777 2.525.123 4.455 0 7.215 0 9 1.57 9 4a4.11 4.11 0 0 1-2.19 3.563c-.909.643-1.345.994-1.345 1.937z" />
      <ellipse cx={4.455} cy={13.5} rx={1.515} ry={1.5} />
    </g>
  </svg>
);

export const __descriptor_QuestionMark = {
  name: "QuestionMark",
  instances: [{ size: 16, Component: QuestionMark16 }],
} as const;
